import { useTranslation } from 'react-i18next'

import { useKeyboard } from '../../../hooks'
import { ConfirmationModal } from '../../Confirmation'

function GretaAIChatDeleteConfirmation({ onCancel, onConfirm }) {
  const { t } = useTranslation()

  useKeyboard(null, onCancel)

  return (
    <ConfirmationModal
      actionButtonsProps={{ submitText: t('Modal.DeleteBtnKey') }}
      description={t('Greta.DeleteChatDescriptionKey')}
      title={t('Greta.DeleteChatTitleKey')}
      onCancel={onCancel}
      onSubmit={onConfirm}
    />
  )
}

export default GretaAIChatDeleteConfirmation
